import React, { useEffect, useState } from "react";
import { useApi } from "../hooks/api";
import { AppRoutes } from "./appRoutes";
import { AuthRoutes } from "./authRoutes";
import { useGlobal } from "../hooks/global";
import { RootRoutes } from "./rootRoutes";
import { ProductFruits } from 'react-product-fruits';

export const Routes: React.FC = () => {
    const { user } = useApi();
    const { clickOnApp } = useGlobal();

    const getRoutes = () => {
        if (!user) return <AuthRoutes />;

        return user?.is_root ? <RootRoutes /> : <AppRoutes />;
    };

    const userInfo = {
        username: user?.email || '',
        email: user?.email || '',
        firstname: user?.surname || '',
        lastname: '',
        signUpAt: '',
        role: user?.user_type?.name || 'ROOT',
        props: { customProp1: '' }
    };

    useEffect(() => {
        if (user?.id) {
            if (document.getElementById('meta-pixel-script')) return;

            const script = document.createElement('script');
            script.id = 'meta-pixel-script';
            script.innerHTML = `
                !function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '1050130577044680');
                fbq('track', 'PageView');
            `;
            document.head.appendChild(script);
        }
    }, [user, user?.id]);

    return (
        <div onClick={clickOnApp} style={{ display: "flex", flex: 1, fontFamily: 'Poppins' }}>
            <ProductFruits workspaceCode="9Uc1MZGgSRkYNY88" language="pt" user={userInfo} />

            {getRoutes()}
        </div>
    )
}
